import { render, staticRenderFns } from "./result.vue?vue&type=template&id=9affbc6a"
import script from "./result.vue?vue&type=script&lang=js"
export * from "./result.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9affbc6a')) {
      api.createRecord('9affbc6a', component.options)
    } else {
      api.reload('9affbc6a', component.options)
    }
    module.hot.accept("./result.vue?vue&type=template&id=9affbc6a", function () {
      api.rerender('9affbc6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/lotto/result.vue"
export default component.exports